import { ProductType } from '~domain/model/core/product-type';
import { ActionType, PolicyModificationConfig, PolicyModificationType } from './models/policy-modification-config';

export const policyModificationOptions: PolicyModificationConfig[] = [
  {
    type: PolicyModificationType.Address,
    productTypes: [ProductType.Car],
    actionType: ActionType.Typeform,
    typeformIds: {
      en: 'NZbUvNBx',
      fr: 'uCbRoJmC',
    },
  },
  {
    type: PolicyModificationType.Address,
    productTypes: [ProductType.Home],
    actionType: ActionType.Typeform,
    typeformIds: {
      en: 'AvTriS1w',
      fr: 'xqwiuCaF',
    },
  },
  {
    type: PolicyModificationType.OccasionalDrivers,
    productTypes: [ProductType.Car],
    actionType: ActionType.Typeform,
    typeformIds: {
      en: 'wMR9SxRr',
      fr: 'fGIuY4f0',
    },
  },
  {
    type: PolicyModificationType.AddReplaceRemoveCar,
    productTypes: [ProductType.Car],
    actionType: ActionType.Typeform,
    typeformIds: {
      en: 'oBDeaqpw',
      fr: 'cZdoU0CE',
    },
  },
  {
    type: PolicyModificationType.CoInsured,
    productTypes: [ProductType.Home],
    actionType: ActionType.Typeform,
    typeformIds: {
      en: 'ppccp0lN',
      fr: 'asyHtFWd',
    },
  },
  {
    type: PolicyModificationType.BankingInformation,
    actionType: ActionType.Typeform,
    typeformIds: {
      en: 'thQtaOM7',
      fr: 'UtobG5',
    },
  },
  // NOTE: Hidden for this https://github.com/YouSet-Insurance/youset/issues/2310
  // {
  //   type: PolicyModificationType.RequestPolicyCopy,
  //   actionType: ActionType.Typeform,
  //   typeformIds: {
  //     en: 'OE8lYgMV',
  //     fr: 'GVQv0Pvj',
  //   },
  // },
  {
    type: PolicyModificationType.Cancellation,
    actionType: ActionType.Typeform,
    typeformIds: {
      en: 'w0Zp4bK5',
      fr: 'VkSdAm',
    },
  },
  {
    type: PolicyModificationType.Claims,
    actionType: ActionType.Redirection,
    linkOptions: {
      openNewTab: true,
      urlByLang: {
        en: 'https://youset.ca/en/claims/',
        fr: 'https://youset.ca/fr/reclamations/',
      },
    },
  },
  {
    type: PolicyModificationType.Help,
    actionType: ActionType.Typeform,
    typeformIds: {
      en: 'Gj46nkNS',
      fr: 'eg0XPBp5',
    },
  },
];
